import { ApprovalStatus, ApprovalStepStatus } from './MediaConstants';

export class ApprovalModel {
	public approvalProcessId: string;
	public approvalProcessName: string;
	public contentAnalysis: IContentAnalysisJob;
	public initialStatus: ApprovalStatus;
	public isStepApprover: boolean;
	public isTemplateApprover: boolean;
	public numberOfSteps: number;
	public numberStepsProcessed: number;
	public selectedTemplateId: string;
	public status: ApprovalStatus;
	public stepId: string;
	public stepName: string;
	public stepStatus: ApprovalStepStatus;
	public whenSubmitted: Date;
}

export interface IContentAnalysisJob {
	jobId: string,
	status: ContentAnalyisJobStatus,
	details: string,
	when: Date,
	translationFileKey: string,
	findingsFileKey: string
}

export enum ContentAnalyisJobStatus {
	PENDING = 'Pending',
	PROCESSING = 'Processing',
	COMPLETED = 'Completed',
	ERROR = 'Error',
	Timeout = 'Timeout',
	Skipped = 'Skipped'
}
